import { render, staticRenderFns } from "./_base-dropdown.vue?vue&type=template&id=89da9be4&"
import script from "./_base-dropdown.vue?vue&type=script&lang=js&"
export * from "./_base-dropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports